
const FILTER_LOCAL_DISPLAY_LIST = 'FILTER_LOCAL_DISPLAY_LIST';


const CLEAR_TYPEAHEAD_LIST_FOR_FIELDID = 'CLEAR_TYPEAHEAD_LIST_FOR_FIELDID';


const clearTypeaheadListForFieldId = (fieldId) => ({
  type: CLEAR_TYPEAHEAD_LIST_FOR_FIELDID,
  payload: {
    fieldId,
  },
});

const filterLocalDisplayList = (fieldId, displayList) => ({
  type: FILTER_LOCAL_DISPLAY_LIST,
  payload: {
    fieldId,
    displayList,
  },
});



const getLocalTypeaheadList = (fieldId, value) => (dispatch, getState) => {

  const state = getState();
  const currentDisplayOptionsData = state.displayOptions.displayOptionsDataById[fieldId];

  if (!currentDisplayOptionsData) {
    console.error(`CANNOT FIND DISPLAY OPTIONS FOR fieldId: ${fieldId} AT state.displayOptions.displayOptionsDataById[fieldId]`);
    return null;
  }

  const {
    hasFetched,
    displayList,
  } = currentDisplayOptionsData;

  if (!hasFetched) {
    // we don't have the list yet
    return null;
  }

  const filteredList = displayList.filter((item) => item.toLowerCase().includes(value.toLowerCase()));

  dispatch(filterLocalDisplayList(fieldId, filteredList));
  return null;
};


export {
  FILTER_LOCAL_DISPLAY_LIST,
  CLEAR_TYPEAHEAD_LIST_FOR_FIELDID,
  getLocalTypeaheadList,
  clearTypeaheadListForFieldId,
};
